import information from '../customerRecordManage/recordFrom/information.vue';
import claimsInfo from '../customerRecordManage/recordFrom/claimsInfo.vue';
import compensationInfo from '../customerRecordManage/recordFrom/compensationInfo.vue';
import { claimsDetail } from './request';
import MailInfo from '../customerRecordManage/recordFrom/mailInfo.vue';
export default {
  components: {
    information,
    claimsInfo,
    compensationInfo,
    MailInfo
  },
  data() {
    return {
      info: null
    };
  },
  created() {
    claimsDetail({
      claimsId: this.$route.params.id
    }).then(res => {
      this.info = res;
    });
  },
  methods: {}
};